import { loadPresignedUrl } from '../tasks';
import { BaseRemoteFile } from './BaseRemoteFile';

export class RemotePresignedFile extends BaseRemoteFile {
  presignedUrl: string;

  constructor() {
    super();

    this.loadFile = async (url: string): Promise<void> => {
      this.presignedUrl = await loadPresignedUrl(url);
      this.onload?.();
    };
  }
}
